<div class="contentPart">
  <div class="containerPart2">
    <img src="assets/img/thaks (2).png" alt="" />
  </div>
</div>
